import React from 'react';

const ChatList = ({ chats, currentChatId, currentChatType, onChatSelect }) => {
    return (
        <div className="chats-list">
            {chats.map(chat => (
                <div
                    key={chat.id}
                    className={`chat-item ${currentChatType === 'private' && currentChatId === chat.id ? 'active' : ''}`}
                    onClick={() => onChatSelect(chat.id, 'private')}
                >
                    <div className="chat-avatar">{chat.avatar}</div>
                    <div className="chat-info">
                        <div className="chat-name">{chat.name}</div>
                        <div className="chat-last-message">{chat.lastMessage}</div>
                    </div>
                    <div className="chat-time">
                        {chat.time}
                        {chat.unread > 0 && <span className="unread-badge">{chat.unread}</span>}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChatList;
